import { ArrowLeft } from "lucide-react";
import { detailCoverForKey } from "../../utils/detailCover";

export function DetailCoverHero({ coverKey, backLabel, onBack }) {
  return (
    <div className="td-hero">
      <img className="td-hero-img" src={detailCoverForKey(coverKey)} alt="" />
      <div className="td-hero-overlay" aria-hidden />
      <button type="button" className="td-back" aria-label={backLabel} onClick={onBack}>
        <ArrowLeft size={18} />
      </button>
    </div>
  );
}

export function DetailCoverShowcase({ coverKey, backLabel, onBack, children, className = "" }) {
  return (
    <div className={`act-detail-showcase has-cover${className ? ` ${className}` : ""}`}>
      <img className="act-detail-cover" src={detailCoverForKey(coverKey)} alt="" />
      <div className="act-detail-cover-overlay" aria-hidden />
      <button type="button" className="act-detail-back" aria-label={backLabel} onClick={onBack}>
        <ArrowLeft size={18} />
      </button>
      <div className="act-detail-cover-content">{children}</div>
    </div>
  );
}
